import React, { useEffect, useState } from "react";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import Box from "../../Box";
import DotStatus from "../../DotStatus";
import { convertIntToMoney } from "../../../helpers/conversions";
import { Loading } from "../../Loading";

ChartJS.register(ArcElement, Tooltip, Legend);

export const options = {
  cutout: '72%',
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      backgroundColor: '#1A1530',
      padding: 10,
      cornerRadius: 8,
      titleFont: { family: 'Inter', size: 12 },
      bodyFont: { family: 'Inter', size: 13, weight: '600' },
      displayColors: true,
      boxPadding: 4,
    }
  },
  maintainAspectRatio: false
}

export const BoxDoughnutChart = ({ type, loading, totalByStatus }) => {
    const [chartData, setChartData] = useState(null);

    useEffect(() => {
      getChartData();
    }, [totalByStatus]);

    const getChartData = () => {
      const toChartData = {
        labels: [],
        datasets: [
          {
            label: '',
            borderWidth: 0,
            hoverOffset: 6,
            borderRadius: 0,
          },
        ],
      };

      let labels = [];
      let data = [];
      let backgroundColor = [];

      if(totalByStatus?.statuses){
        totalByStatus.statuses.map((total, index) => {
          labels[index] = total.status.name;
          data[index] = total.total_resources;
          backgroundColor[index] = total.status.color;
        });
      }

      toChartData.labels = labels;
      toChartData.datasets[0].data = data;
      toChartData.datasets[0].backgroundColor = backgroundColor;

      setChartData(toChartData);
    }

    const totalCount = totalByStatus?.totals?.count ?? 0;
    const hasData = totalCount > 0;

    return (
        <Box title={`Distribuição por status`}>
          <div className="doughnut-chart">
            <div className="doughnut-chart-canvas">
              {loading &&
                <Loading show={true} />
              }
              {chartData !== null && !loading &&
                <>
                  <Doughnut data={chartData} options={options} />
                  <div className="doughnut-chart-center">
                    <span className="value">{totalCount}</span>
                    <span className="label">{type === 'budget' ? 'orçamentos' : 'pedidos'}</span>
                  </div>
                </>
              }
            </div>

            {!loading && !hasData &&
              <p className="doughnut-chart-empty">Nenhum resultado no período selecionado.</p>
            }

            {!loading && hasData &&
              <table className="chart-table">
                <thead>
                  <tr>
                    <th align="left">Status</th>
                    <th align="right">Qtd.</th>
                    <th align="right">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {totalByStatus.statuses.map((total, index) => (
                    <tr key={index}>
                      <td><DotStatus color={total.status.color} size={10} /> {total.status.name}</td>
                      <td align="right">{total.total_resources}</td>
                      <td align="right">R$ {convertIntToMoney(total.amount_resources)}</td>
                    </tr>
                  ))}
                  <tr className="chart-table-total">
                    <td>Total</td>
                    <td align="right"><b>{totalByStatus?.totals?.count}</b></td>
                    <td align="right"><b>{totalByStatus?.totals ? `R$ ${convertIntToMoney(totalByStatus?.totals?.amount)}` : 'R$ 0,00'}</b></td>
                  </tr>
                </tbody>
              </table>
            }
          </div>
        </Box>
    );
}

export default BoxDoughnutChart;
